var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useState } from "react";
import { FiPlus } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useTitle from "../../hooks/useTitle";
import api from "../../services/api";
import AddressTab from "./../CompaniesTab/Address";
import LicensessTab from "./../CompaniesTab/Licenses";
import OtherInfosTab from "./../CompaniesTab/OtherInfo";
import Libraries from "./../CompaniesTab/Libraries";
import UsersTab from "./../CompaniesTab/Users";
import ModalCompany from "./../Modals/ModalCompany";
import Implementation from "./../CompaniesTab/Implementation";
import { Button, InputText, InputSelect, TabContents, InputDate } from 'template/lib';
import * as Yup from 'yup';
import styles from './styles.module.scss';
import Select from 'react-select';
var Company = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var _p = useAuth(), login = _p.login, handleLogout = _p.handleLogout;
    var setTitle = useTitle().setTitle;
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var _q = useState(0), id = _q[0], setId = _q[1];
    var _r = useState([]), supportOpt = _r[0], setSupportOpt = _r[1];
    var _s = useState([]), companiesToSelect = _s[0], setCompaniesToSelect = _s[1];
    var _t = useState(), companyInfo = _t[0], setCompanyInfo = _t[1];
    var _u = useState([]), tabs = _u[0], setTabs = _u[1];
    var _v = useState([]), statusSelect = _v[0], setStatusSelect = _v[1];
    var _w = useState(false), refresh = _w[0], setRefresh = _w[1];
    var _x = useState([]), modalityOptions = _x[0], setModalityOptions = _x[1];
    var _y = useState(false), showBtnCreateApontamentoDB = _y[0], setShowBtnCreateApontamentoDB = _y[1];
    useEffect(function () {
        setTitle('Empresas');
        if (login && Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
            handleLogout();
            history.push('/');
        }
        if (!login) {
            history.push('/');
        }
        api.get('/companies', config).then(function (response) {
            setCompaniesToSelect(response.data);
        });
    }, []);
    useEffect(function () {
        if (id === 0) {
            return;
        }
        api.get("/companies/" + id, config).then(function (response) {
            setStatusSelect(response.data.status.select);
            setSupportOpt(response.data.helper.select);
            setModalityOptions(response.data.modality.select);
            setCompanyInfo(response.data);
            setTabs([
                {
                    name: 'Endereço',
                    ComponentVal: _jsx(AddressTab, { companyId: id }, void 0)
                },
                {
                    name: 'Usuários',
                    ComponentVal: _jsx(UsersTab, { companyId: id }, void 0)
                },
                {
                    name: 'Licenças',
                    ComponentVal: _jsx(LicensessTab, { companyId: id }, void 0)
                },
                {
                    name: 'Informações',
                    ComponentVal: _jsx(OtherInfosTab, { companyId: id }, void 0)
                },
                {
                    name: 'Bibliotecas',
                    ComponentVal: _jsx(Libraries, { companyId: id }, void 0)
                },
                {
                    name: 'Implantação',
                    ComponentVal: _jsx(Implementation, { companyId: id }, void 0)
                }
            ]);
        });
        api
            .get("/central/check-contract-apontamento?idCompany=" + id + "&dataBaseApp=Apontamento", config)
            .then(function (response) {
            setShowBtnCreateApontamentoDB(!response.data.contractExists && response.data.licenseApontamento && (login === null || login === void 0 ? void 0 : login.role) == 'Administrator');
        })
            .catch(function (error) {
            console.error("Erro ao verificar base:", error.response.data);
        });
    }, [id]);
    var handleFindCompanyById = function (e) {
        //e.preventDefault()
        //setId(e.target.value)
        setId(e.value);
    };
    var companies = {
        label: 'Empresa',
        options: companiesToSelect
    };
    var handleCreateBase = function () {
        if (!id) {
            console.log("ID não está definido");
            return;
        }
        // Usando axios para enviar o POST com parâmetros na URL
        api.post("/central/new-base", null, __assign({ params: {
                idCompany: id,
                dataBaseApp: "Apontamento"
            } }, config))
            .then(function (response) {
            alert("Base criada com sucesso!");
            setShowBtnCreateApontamentoDB(false);
        })
            .catch(function (error) {
            console.log("Erro ao criar a base: " + error.response.data);
            alert("Erro ao criar a base: " + error.response.data);
        });
    };
    var optionsCompanies = companiesToSelect.map(function (item) {
        return {
            label: item.name,
            value: item.id
        };
    });
    var statusSelcts = {
        label: 'Status Empresa',
        options: statusSelect
    };
    var supportSelcts = {
        label: 'Técnico',
        options: supportOpt
    };
    var modalitySelect = {
        label: 'Modalidade',
        options: modalityOptions
    };
    var history = useHistory();
    var _z = useState(false), modalIsOpenCompany = _z[0], setIsOpenCompany = _z[1];
    var _0 = useState(false), saveBtn = _0[0], setSaveBtn = _0[1];
    function handleOpenModalCompany() {
        setIsOpenCompany(true);
    }
    function handlecloseModalCompany() {
        setIsOpenCompany(false);
    }
    var compnaySchema = Yup.object().shape({
        name: Yup.string()
            .required('O campo Nome é obrigatório.')
            .max(50, 'O campo Nome deve conter no máximo 50 caracteres.'),
        helper: Yup.string()
            .required('O campo Técnico é obrigatório.'),
        wpsId: Yup.number()
            .required('O campo Wps Id é obrigatório.')
            .moreThan(0, 'O campo Wps Id deve ser maior que zero.')
            .max(2147483647, 'O valor máximo para o campo Wps Id é 2147483647.'),
        cpf: Yup.string()
            .nullable()
            .matches(/^[0-9]+$/, 'O campo CPF deve conter apenas números.')
            .min(11, 'O campo CPF deve conter 11 dígitos.')
            .max(11, 'O campo CPF deve conter 11 dígitos.'),
        cnpj: Yup.string()
            .nullable()
            .matches(/^[0-9]+$/, 'O campo CNPJ deve conter apenas números.')
            .min(14, 'O campo CNPJ deve conter 14 dígitos.')
            .max(14, 'O campo CNPJ deve conter 14 dígitos.'),
    });
    var formatDate = function (dateString) {
        if (!dateString)
            return '';
        return dateString.split('T')[0];
    };
    var formik = useFormik({
        initialValues: {
            name: (_a = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.name) !== null && _a !== void 0 ? _a : '',
            helper: (_c = (_b = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.helper) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : '',
            status: (_e = (_d = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.status) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : '',
            wpsId: (_f = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.wpsId) !== null && _f !== void 0 ? _f : '',
            cpf: (_g = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.cpf) !== null && _g !== void 0 ? _g : '',
            cnpj: (_h = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.cnpj) !== null && _h !== void 0 ? _h : '',
            isImplantation: (_j = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.isImplantation) !== null && _j !== void 0 ? _j : false,
            registrationDate: formatDate(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.registrationDate),
            modality: (_l = (_k = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.modality) === null || _k === void 0 ? void 0 : _k.id) !== null && _l !== void 0 ? _l : ''
        },
        enableReinitialize: true,
        validationSchema: compnaySchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_a) {
                payload = __assign(__assign({}, values), { wpsId: Number(values.wpsId), modality: values.modality || undefined, registrationDate: formatDate(values.registrationDate) });
                api.put("/companies/" + (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.id), payload, config)
                    .then(function () { return setSaveBtn(false); });
                return [2 /*return*/];
            });
        }); }
    });
    var customStyles = {
        control: function (provided) { return (__assign(__assign({}, provided), { minHeight: "20px", boxShadow: 'none', fontSize: "14px !important" })); },
        input: function (provided) { return (__assign(__assign({}, provided), { padding: "0px" })); },
        path: function (provided) { return (__assign(__assign({}, provided), { fill: "black" })); },
        indicatorsContainer: function (provided) { return (__assign(__assign({}, provided), { height: "20px" })); },
        indicatorSeparator: function (provided) { return (__assign(__assign({}, provided), { height: "0px" })); },
        dropdownIndicator: function (provided) { return (__assign(__assign({}, provided), { padding: "2px", color: "black" })); }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: styles.container }, { children: [_jsxs("div", __assign({ className: styles.divSelectCompany }, { children: [_jsx("label", { children: "Empresa:" }, void 0), _jsx(Select, { styles: customStyles, placeholder: 'Selecione uma empresa', options: optionsCompanies, onChange: function (e) {
                                    handleFindCompanyById(e);
                                    setSaveBtn(false);
                                }, className: styles.selectCompany }, void 0), _jsx("div", __assign({ className: '' }, { children: _jsx(FiPlus, { title: 'Nova Empresa', size: 16, className: 'cursor-pointer mt-1', onClick: handleOpenModalCompany }, void 0) }), void 0)] }), void 0), companyInfo &&
                        _jsx(_Fragment, { children: _jsx("form", __assign({ onSubmit: formik.handleSubmit }, { children: _jsxs("div", __assign({ className: styles.gridCompanyInfo }, { children: [_jsxs("div", __assign({ className: "grid grid-cols-3 md:grid-cols-" + 3 + " lg:grid-cols-" + 3 + " justify-items-end" }, { children: [_jsx(InputText, { disabled: true, onChange: formik.handleChange, name: 'id', label: 'ID', inicialValue: companyInfo.id || '' }, void 0), _jsx(InputText, { onChange: function (e) {
                                                        formik.handleChange(e);
                                                        setSaveBtn(true);
                                                    }, name: 'name', label: 'Nome', inicialValue: formik.values.name || '' }, void 0), _jsx(InputSelect, { name: "status", value: (_m = formik.values.status) !== null && _m !== void 0 ? _m : '', disabled: (login === null || login === void 0 ? void 0 : login.role) !== 'Administrator', values: statusSelcts, valueMember: "id", displayMember: "name", onChange: function (e) {
                                                        formik.setFieldValue('status', e.target.value);
                                                        setSaveBtn(true);
                                                    } }, void 0), _jsx(InputSelect, { name: "helper", value: formik.values.helper || '', values: supportSelcts !== null && supportSelcts !== void 0 ? supportSelcts : [], valueMember: "id", displayMember: "name", onChange: function (e) {
                                                        formik.setFieldValue('helper', e.target.value);
                                                        setSaveBtn(true);
                                                    } }, void 0), _jsx(InputText, { name: "wpsId", label: "Wps Id", inicialValue: formik.values.wpsId || '', onChange: function (e) {
                                                        formik.handleChange(e);
                                                        setSaveBtn(true);
                                                    } }, void 0), _jsx(InputText, { name: "cpf", label: "CPF", inicialValue: formik.values.cpf || '', onChange: function (e) {
                                                        formik.handleChange(e);
                                                        setSaveBtn(true);
                                                    } }, void 0), _jsx(InputText, { name: "cnpj", label: "CNPJ", inicialValue: formik.values.cnpj || '', onChange: function (e) {
                                                        formik.handleChange(e);
                                                        setSaveBtn(true);
                                                    } }, void 0), _jsx(InputDate, { name: "registrationDate", label: "Data Cadastro", value: formik.values.registrationDate || '', onChange: function (e) {
                                                        formik.setFieldValue('registrationDate', e.target.value);
                                                        setSaveBtn(true);
                                                    } }, void 0), _jsxs("div", __assign({ className: styles.containerCheckBoxInput }, { children: [_jsx("label", __assign({ className: styles.labelImplantationa }, { children: "Implanta\u00E7\u00E3o:" }), void 0), _jsx("input", { onChange: function (e) {
                                                                formik.handleChange(e);
                                                                setSaveBtn(true);
                                                            }, name: 'isImplantation', type: "checkbox", checked: formik.values.isImplantation }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.inputSelectModality }, { children: _jsx(InputSelect, { resize: true, name: "modality", value: (_o = formik.values.modality) !== null && _o !== void 0 ? _o : '', values: modalitySelect, valueMember: "id", displayMember: "name", onChange: function (e) {
                                                            formik.setFieldValue('modality', e.target.value);
                                                            setSaveBtn(true);
                                                        } }, void 0) }), void 0), showBtnCreateApontamentoDB &&
                                                    _jsx("div", { children: _jsx(Button, __assign({ onClick: handleCreateBase }, { children: "Criar Base Apontamento" }), void 0) }, void 0)] }), void 0), formik.errors.name && formik.touched.name && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.name }), void 0), formik.errors.helper && formik.touched.helper && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.helper }), void 0), formik.errors.wpsId && formik.touched.wpsId && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.wpsId }), void 0), formik.errors.cpf && formik.touched.cpf && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.cpf }), void 0), formik.errors.cnpj && formik.touched.cnpj && _jsx("i", __assign({ className: 'w-full flex justify-center text-red-400' }, { children: formik.errors.cnpj }), void 0), saveBtn &&
                                            _jsx("div", __assign({ className: styles.saveButton }, { children: _jsx(Button, __assign({ type: 'submit' }, { children: "Salvar" }), void 0) }), void 0)] }), void 0) }), void 0) }, void 0), _jsx(TabContents, { contents: tabs }, void 0)] }), void 0), _jsx(ModalCompany, { setId: setId, setRefresh: setRefresh, modalIsOpenCompany: modalIsOpenCompany, handleOpenModalCompany: handleOpenModalCompany, handlecloseModalCompany: handlecloseModalCompany }, void 0)] }, void 0));
};
export default Company;
